// extracted by mini-css-extract-plugin
export default {"new-measure":"_new-measure_i-7W6F"};